/*
 * @Author: shannyHuang
 * @Date: 2022-02-28 10:56:47
 * @LastEditors: brucexlliu
 * @LastEditTime: 2022-09-07 16:54:06
 * @FilePath: \wemeet-web-activity\src\pages\_error.page.tsx
 */

import React, { useCallback } from 'react';
import { NextPageContext } from 'next';
import AbnormalState from '@tencent/tpm-meeting-active/lib/AbnormalState';
import '@tencent/tpm-meeting-active/lib/AbnormalState/style';
import { Button } from '@tencent/tea-component';

function Error({ statusCode, err }: { statusCode?: number; err?: NextPageContext['err'] }) {
  const lowBrowser = statusCode === 10001;
  const onClick = useCallback(() => {
    window.history.back();
  }, []);

  try {
    window.nextAegis.infoAll(`[Page Error] - url=${location.href}; 
      [statusCode]=${err?.statusCode};
      message=${err?.name}:${err?.message};
      stack=${err?.stack};
      `);
  } catch (e) {
    // 错误处理
  }

  return (
    <div style={{ height: '100vh' }}>
      <AbnormalState
        state={lowBrowser ? 'upgrade' : 'invalid'}
        title={lowBrowser ? '糟糕，您的浏览器版本过低～' : '糟糕，内容已失效～'}
        desc={
          lowBrowser ? (
            '为了更好的体验，请升级您的浏览器'
          ) : (
            <>
              您所寻找的页面内容已失效，可以点击下方按钮<p>返回上一页</p>
            </>
          )
        }
        operation={
          !lowBrowser && (
            <Button type="primary" onClick={onClick}>
              返回上一页
            </Button>
          )
        }
      />
    </div>
  );
}

Error.getInitialProps = ({ res, err }: NextPageContext) => {
  // eslint-disable-next-line no-nested-ternary
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
  return { statusCode, err };
};

export default Error;
